module.exports = __webpack_public_path__ + "img/jichang.ba8c3026.png";